import { render, staticRenderFns } from "./SendSMSPublic.vue?vue&type=template&id=a1f80486&scoped=true&"
import script from "./SendSMSPublic.vue?vue&type=script&lang=js&"
export * from "./SendSMSPublic.vue?vue&type=script&lang=js&"
import style0 from "./SendSMSPublic.vue?vue&type=style&index=0&id=a1f80486&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f80486",
  null
  
)

export default component.exports